import React, { useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { Loader, LoaderModeType } from 'components/Loader';
import { OrderSelector } from './components/OrderSelector';
import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { PermissionGate } from 'components/PermissionGate';

import { deliveriesUpdatedHandler } from '../utils/deliverySubscriptionsHandlers';
import { UltraSelect } from 'components/UltraSelect';
import { organizationSource } from 'data/entity-sources/sources';

import { useCreateDeliveryForOrderMutation, TotadminPermission } from 'data/__generated__';

export function CreateDeliveryPopup({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (arg: boolean) => void }) {
    const [orderId, setOrderId] = useState<string | null>(null);
    const [organizationId, setOrganizationId] = useState<string | null>(null);

    const [createDeliveryForOrder, { loading }] = useCreateDeliveryForOrderMutation();

    async function handleSubmit() {
        if (orderId) {
            const { data } = await createDeliveryForOrder({ variables: { orderId } });

            if (!data) {
                throw new Error('Une erreur est survenue lors de la création de la livraison');
            }

            const { createDeliveryForOrder: createdOrder } = data;

            if (createdOrder) {
                deliveriesUpdatedHandler([createdOrder]);
                toast.success('Livraison créée !');
                setIsOpen(false);
            }
        }
    }

    return (
        <TotemPopup
            title="Créer une livraison freefood"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            contentOverflow="visible"
        >
            <UltraSelect
                source={organizationSource}
                label="Choisir une organisation"
                value={organizationId}
                onChange={setOrganizationId}
            />

            {organizationId ? (
                <OrderSelectorContainer>
                    <PermissionGate requiredPermissions={[TotadminPermission.OrdersRead]}>
                        <OrderSelector
                            selectedOption={orderId}
                            setSelectedOption={setOrderId}
                            organizationId={organizationId}
                        />
                    </PermissionGate>
                </OrderSelectorContainer>
            ) : null}

            <SubmitContainer>
                <TotemPrimaryButton
                    onClick={handleSubmit}
                    disabled={!orderId}
                    requiredPermissions={[TotadminPermission.DeliveriesManage]}
                >
                    {loading ? <Loader size="20px" mode={LoaderModeType.Spin} /> : 'Confirmer'}
                </TotemPrimaryButton>
            </SubmitContainer>
        </TotemPopup>
    );
}

const SubmitContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 15px;
`;

const OrderSelectorContainer = styled.div`
    margin-top: 30px;
`;
